<template>
  <div class="page-content">
    <el-breadcrumb  separator="/">
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      <el-breadcrumb-item><span style="cursor: pointer;" @click="onChangePage">资料信息</span></el-breadcrumb-item>
      <el-breadcrumb-item v-if="isBindMobile">修改绑定</el-breadcrumb-item>
      <el-breadcrumb-item v-if="isUpdatePassword">修改密码</el-breadcrumb-item>
    </el-breadcrumb>
    <!--资料信息页 -->
    <div v-if="!isBindMobile && !isUpdatePassword" style="height: 300px;">
      <el-col :span="7" style="padding-left: 10px;padding-right: 10px;">
        <div style="height: 750px;display: block;border-radius: 16px" class="g-content-box g-vertical-center">
          <div style="width: 100%;text-align: center;">
            <el-image style="width: 100px;margin-top: 64px;" :src="smallLogo"></el-image>
          </div>
          <span v-if="myInfo.usertype == 'HCMSUB'" class="g-block" style="font-size: 20px; font-weight: bold; padding: 40px 0 60px;text-align: center;">{{ myInfo.companyname }}:{{ myInfo.realname }}</span>
          <span v-else class="g-block" style="font-size: 20px; font-weight: bold; padding: 40px 0 60px;text-align: center;">{{ myInfo.companyname }}</span>
          <div style="height: 500px;overflow: auto;">
            <div class="myinfo-detail-item" style="padding-top: 20px">
              <el-row style="border-bottom: 1px solid #ebeef5; padding-bottom: 8px">
                <el-col :span="24">
                  <i class="el-icon-user myinfo-icon"></i>
                  <span class="g-margin-left" style="font-weight: bold">
                    用户名：
                  </span>
                </el-col>
                <el-col :span="18" style="padding-top: 8px">
                  <span style="margin-left: 30px" v-if="myInfo.usertype == 'HCMSUB'">
                    {{ userInfo.username }}
                  </span>
                  <span style="margin-left: 30px" v-else>
                    {{ userInfo.username }}
                  </span>
                </el-col>
                <el-col :span="6" style="padding-top: 8px; text-align: right">
                  <span @click="onUpdatePassword" class="myinfo-btn">
                    修改密码
                  </span>
                </el-col>
              </el-row>
            </div>

            <div class="myinfo-detail-item" style="padding-top: 8px">
              <el-row style="border-bottom: 1px solid #ebeef5; padding-bottom: 8px">
                <el-col :span="24">
                  <img class="myinfo-icon myinfo-img" :src="phone" alt="" />
                  <span class="g-margin-left" style="font-weight: bold">
                    绑定手机
                    <span v-if="userInfo.xcxopenid">
                      （已注册小程序）
                    </span>
                    ：
                  </span>
                </el-col>
                <el-col :span="18" style="padding-top: 8px">
                  <span style="margin-left: 30px">
                    {{ userInfo.mobile ? userInfo.mobile : "-" }}
                  </span>
                </el-col>
                <el-col :span="6" style="padding-top: 8px; text-align: right">
                  <span @click="onBindMobile" class="myinfo-btn">
                    {{ hasMobile ? "修改绑定" : "立即绑定" }}
                  </span>
                </el-col>
                <el-col :span="24" style="padding-top: 8px; padding-left: 27px">
                  <span class="myinfo-btn" style="color: #00000072">
                    用于找回密码验证身份
                  </span>
                </el-col>
              </el-row>
            </div>

            <div style="border-bottom: 1px solid #DCDFE6;padding-top: 20px;">
              <img class="myinfo-icon myinfo-img" :src="wechat" alt="">
              <span class="g-margin-left" style="font-weight: bold;" v-if="userInfo.xcxopenid">
                绑定微信公众号
              </span>
              <span class="g-margin-left" style="font-weight: bold;" v-else>
                绑定微信
              </span>
              <div style="margin-top: 10px;color: #808080;height: 50px;padding-bottom: 20px;">
                <div style="float: left;margin-left: 30px;">
                  {{ userInfo.openid ? userInfo.nickname.length>8?userInfo.nickname.slice(0,8)+'...':userInfo.nickname : '未绑定' }}
                </div>
                <div style="float: right;padding-bottom: 10px;width: 300px;text-align: right;">
                  <span @click="onBindWechat(userInfo.openid)" class="myinfo-btn" v-if="!userInfo.openid">立即绑定</span>
                  <el-popover
                    placement="left"
                    width="240"
                    v-model="visibleShow">
                    <div style="display: flex;width: 100%;justify-content:center;">
                      <i class="el-icon-warning" style="color:#faad14;font-size: 24px;"></i>
                      <div>
                        <div style="font-size: 16px;">
                          你确认要解绑微信绑定吗？
                        </div>
                        <div style="font-size: 14px;">解绑后
                          <span style="color: #e90e24;font-size: 14px;">
                            将失去消息推送和扫码登录功能
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style="text-align: right;">
                      <el-button type="primary" @click="onBindWechat(userInfo.openid)" size="mini">确 定</el-button>
                      <el-button @click="visibleShow = false" size="mini" type="TheCustom">取 消</el-button>
                    </div>
                    <span slot="reference" class="myinfo-btn" v-if="userInfo.openid" @click="visibleShow = true">解除绑定</span>
                  </el-popover>
                </div>
                <div style="color: gray;clear: both;margin-left: 30px;">绑定微信后可便捷接收消息提醒和微信扫码登录</div>
              </div>
            </div>

            <div class="myinfo-detail-item" style="padding-top: 8px" v-if="userInfo.usertype != 'KEFU'">
              <el-row style="border-bottom: 1px solid #ebeef5; padding-bottom: 8px">
                <el-col :span="24">
                  <img class="myinfo-icon myinfo-img" :src="email" alt="" />
                  <span class="g-margin-left" style="font-weight: bold">
                    绑定邮箱：
                  </span>
                </el-col>
                <el-col :span="18" style="padding-top: 8px">
                  <span style="margin-left: 30px">
                    {{ userInfo.email ? userInfo.email : "-" }}
                  </span>
                </el-col>
                <el-col :span="6" style="padding-top: 8px; text-align: right">
                  <span @click="onBindemail(userInfo.email)" class="myinfo-btn">
                    {{ userInfo.email ? "修改绑定" : "立即绑定" }}
                  </span>
                </el-col>
                <el-col :span="24" style="padding-top: 8px; padding-left: 27px">
                  <span class="myinfo-btn" style="color: #00000072">
                    绑定邮箱后可便捷接收消息提醒和通知公告信息
                  </span>
                </el-col>
              </el-row>
            </div>
            <div class="myinfo-detail-item" style="padding-top: 8px" v-if="userInfo.usertype != 'KEFU'">
              <el-row style="border-bottom: 1px solid #ebeef5; padding-bottom: 8px">
                <el-col :span="24">
                  <img class="myinfo-icon myinfo-img" :src="down" alt="" />
                  <span class="g-margin-left" style="font-weight: bold">
                    下载插件：
                  </span>
                </el-col>
                <el-col :span="8" style="padding-top: 8px;padding-left: 30px;">
                  <span @click="onBindDown(1)" class="myinfo-btn">
                    插件下载
                  </span>
                </el-col>
                <el-col :span="8" style="padding-top: 8px;padding-left: 27px;text-align: center;">
                  <span @click="onBindDown(2)" class="myinfo-btn">
                    浏览器下载
                  </span>
                </el-col>
                <el-col :span="8" style="padding-top: 8px;text-align: right;">
                  <span @click="onBindDown(3)" class="myinfo-btn">
                    使用说明
                  </span>
                </el-col>
                <el-col :span="24" style="padding-top: 8px; padding-left: 27px">
                  <span class="myinfo-btn" style="color: #00000072">
                    下载后放入360极速浏览器即可使用
                  </span>
                </el-col>
              </el-row>
            </div>

            <div class="myinfo-detail-item" style="padding-top: 20px">
              <el-row style="padding-bottom: 8px" >
                <el-col :span="24">
                  <img class="myinfo-icon myinfo-img" :src="calendar" alt="">
                  <span class="g-margin-left" style="font-weight: bold">
                    业务有效期至：
                  </span>
                </el-col>
                <el-col :span="18" style="padding-top: 8px">
                  <span style="margin-left: 30px" >
                    {{ myInfo.validtimebrm|yearMonthDayTime }}
                  </span>
                </el-col>
                <el-col :span="18" style="padding-top: 8px">
                  <span style="margin-left: 30px;color: gray;">
                    有效期过期后，BRM业务将不能正常使用
                  </span>
                </el-col>
              </el-row>
            </div>

          </div>
        </div>
      </el-col>
      <el-col :span="17" style="padding-left: 10px;padding-right: 10px;">
        <div style="height: 750px;display: block;border-radius: 16px" class="g-content-box g-vertical-center">
          <div style="font-weight: bold;font-size: 18px;">
            微信消息提醒设置
          </div>
          <div class="myinfo-detail-item" style="padding-top: 20px">
            <el-row style="border-bottom: 1px solid #ebeef5; padding-bottom: 8px">
              <el-col :span="24">
                <span class="g-margin-left" style="font-weight: bold">
                  绑定微信后，系统业务相关消息将以微信公众号消息形式推送
                </span>
              </el-col>
            </el-row>
          </div>

          <div class="myinfo-detail-item" style="padding-top: 20px;">
            <el-row style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;">
              <el-col :span="20">
                <div style="font-weight: bold;font-size: 16px;">
                  通知公告消息提醒
                </div>
                <div style="font-weight: bold">
                  开启后，系统发布的通知公告消息，将以微信公众号消息形式推送提醒。
                </div>
              </el-col>
              <el-col :span="4">
                <el-switch
                  @change="updateWechar(1)"
                  style="height: 47px;line-height: 47px;"
                  v-model="wechar_notice"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-row>
          </div>

          <div class="myinfo-detail-item" style="padding-top: 20px;">
            <el-row style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;">
              <el-col :span="20">
                <div style="font-weight: bold;font-size: 16px;">
                  违规举报初审消息提醒
                </div>
                <div style="font-weight: bold">
                  开启后，店铺经销商举报的违规信息审核，将以微信公众号消息形式推送提醒。
                </div>
              </el-col>
              <el-col :span="4">
                <el-switch
                  @change="updateWechar(2)"
                  style="height: 47px;line-height: 47px;"
                  v-model="wechar_report_trial"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-row>
          </div>

          <div class="myinfo-detail-item" style="padding-top: 20px;">
            <el-row style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;">
              <el-col :span="20">
                <div style="font-weight: bold;font-size: 16px;">
                  授权违规举报待复查消息提醒
                </div>
                <div style="font-weight: bold">
                  开启后，店铺经销商响应整改后信息复查，将以微信公众号消息形式推送提醒。
                </div>
              </el-col>
              <el-col :span="4">
                <el-switch
                  @change="updateWechar(3)"
                  style="height: 47px;line-height: 47px;"
                  v-model="wechar_report_review"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-row>
          </div>

          <div class="myinfo-detail-item" style="padding-top: 20px;">
            <el-row style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;">
              <el-col :span="20">
                <div style="font-weight: bold;font-size: 16px;">
                  授权违规举报申诉待评定消息提醒
                </div>
                <div style="font-weight: bold">
                  开启后，店铺经销商响应申诉的信息评定，将以微信公众号消息形式推送提醒。
                </div>
              </el-col>
              <el-col :span="4">
                <el-switch
                  @change="updateWechar(4)"
                  style="height: 47px;line-height: 47px;"
                  v-model="wechar_report_appeal"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-row>
          </div>

          <div class="myinfo-detail-item" style="padding-top: 20px;">
            <el-row style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;">
              <el-col :span="20">
                <div style="font-weight: bold;font-size: 16px;">
                  活动待审批消息提醒
                </div>
                <div style="font-weight: bold">
                  开启后，店铺经销商提交的活动信息审批，将以微信公众号消息形式推送提醒。
                </div>
              </el-col>
              <el-col :span="4">
                <el-switch
                  @change="updateWechar(5)"
                  style="height: 47px;line-height: 47px;"
                  v-model="wechar_campaign_trial"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-row>
          </div>

          <div class="myinfo-detail-item" style="padding-top: 20px;">
            <el-row style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;">
              <el-col :span="20">
                <div style="font-weight: bold;font-size: 16px;">
                  活动转审待审批消息提醒
                </div>
                <div style="font-weight: bold">
                  开启后，其他同事转审给你的活动信息审批，将以微信公众号消息形式推送提醒。
                </div>
              </el-col>
              <el-col :span="4">
                <el-switch
                  @change="updateWechar(6)"
                  style="height: 47px;line-height: 47px;"
                  v-model="wechar_campaign_referral"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
    </div>

    <el-dialog title="编辑" :visible.sync="theEditorShow" width="20%" style="margin-top: 10%;">
      <el-form>
        <el-form-item label="邮箱" label-width="60px">
          <el-input v-model="exEmail" placeholder="请输入邮箱" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()" size="small">确 定</el-button>
        <el-button @click="theEditorShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
    <!--绑定手机页 -->
    <div v-if="isBindMobile">
      <div class="g-content-box" v-if="hasMobile">
        <el-steps :active="currentMobileStep">
          <el-step title="验证身份" description="需要使用当前绑定手机验证身份"></el-step>
          <el-step title="绑定新手机" description="请填写你需要绑定的新手机号"></el-step>
          <el-step title="绑定成功" description="成功绑定新手机号码"></el-step>
        </el-steps>
      </div>


      <div v-if="hasMobile && currentMobileStep === 0" class="myinfo-mobile-box">
        <el-form :model="mobile" ref="mobile" label-width="80px" class="myinfo-mobile-form">
          <el-form-item>
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 20px;">
              手机号
            </div>
            <img class="myinfo-icon myinfo-img" :src="phone" alt="">
            <span style="font-weight: bold;padding-left: 10px;">{{ userInfo.mobile }}</span>
          </el-form-item>
          <el-form-item class="myinfo-code-item">
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 20px;">
              验证码
            </div>
            <el-input v-model="mobile.code" class="myinfo-code-input" placeholder="输入验证码"></el-input>
            <el-button :disabled="Boolean(codeNumber)" class="g-margin-left" @click="getMobileCode(1)">
              <span v-if="!codeNumber">获取验证码</span>
              <span v-else>{{ codeNumber }}s后重新发送</span>
            </el-button>

            <p v-if="codeNumber">
              <i class="el-icon-success" style="color: #3FB838"></i>
              <span class="g-margin-left">
                验证码已发送到你的手机，5分钟内输入有效
              </span>
              <span class="g-block" style="padding-left: 24px">
                验证码等同于密码，打死也不能告诉别人!
              </span>
            </p>
          </el-form-item>
          <el-form-item style="margin-top: 80px;">
            <el-button size="medium" class="g-confirm-btn" @click="onConfirmCode(1)">确定</el-button>
            <el-button size="medium" class="g-cancel-btn" @click="isBindMobile = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="(hasMobile && currentMobileStep === 1) || (!hasMobile && currentMobileStep === 0)" class="myinfo-mobile-box">
        <el-form :model="newmobile" :rules="mobileRules" ref="newmobile" label-width="80px" class="myinfo-mobile-form">
          <el-form-item prop="mobile">
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 20px;">
              手机号
            </div>
            <el-input v-enter-number v-model="newmobile.mobile" placeholder="输入新手机号" style="width: 360px;"></el-input>
          </el-form-item>
          <el-form-item class="myinfo-code-item">
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 20px;">
              验证码
            </div>
            <el-input v-model="newmobile.code" class="myinfo-code-input" style="width: 184px;" placeholder="输入验证码"></el-input>
            <el-button :disabled="Boolean(codeNumber)" class="g-margin-left" style="width: 250px;" @click="getMobileCode(2)">
              <span v-if="!codeNumber">获取验证码</span>
              <span v-else>{{ codeNumber }}s后重新发送</span>
            </el-button>

            <p v-if="codeNumber">
              <i class="el-icon-success" style="color: #3FB838"></i>
              <span class="g-margin-left">
                验证码已发送到你的手机，5分钟内输入有效
              </span>
              <span class="g-block" style="padding-left: 24px">
                验证码等同于密码，打死也不能告诉别人!
              </span>
            </p>
          </el-form-item>
          <el-form-item style="margin-top: 70px;">
            <el-button size="medium" class="g-confirm-btn" @click="onConfirmCode(2)">提交</el-button>
            <el-button size="medium" class="g-cancel-btn" @click="isBindMobile = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="currentMobileStep === 2" class="myinfo-mobile-box myinfo-bind-success">
        <i class="el-icon-success" style="color: #3FB838;font-size: 40px;display: block"></i>
        <p>绑定成功</p>
        <p>新登录方式:使用新手机号和密码登录</p>
        <el-button size="small" class="g-confirm-btn" @click="isBindMobile = false;load()">完成</el-button>
      </div>


      </div>
       <!-- 修改密码页 -->
      <div v-if="isUpdatePassword">
      <div class="myinfo-mobile-box">
        <el-form :model="password" :rules="passwordRules" ref="password" label-width="100px" class="myinfo-mobile-form">
          <el-form-item prop="current">
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 20px;">
              当前密码
            </div>
            <el-input type="password" v-model="password.current" placeholder="输入当前密码"></el-input>
          </el-form-item>
          <el-form-item prop="new">
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 20px;">
              新密码
            </div>
            <el-popover
              placement="right"
              trigger="focus"
              width="150"
              >
              <div >
                <span>
                  强度: &nbsp; {{ passwordPercent === 33 ? '弱' : passwordPercent === 100 ? '强' : '中'  }}
                </span>
                <el-progress
                  :show-text="false"
                  :percentage="passwordPercent"
                  :color="customColors">
                </el-progress>
                <span class="g-block">
                  请至少输入6个字符，请不要使用容易被猜到的密码
                </span>
              </div>
              <div slot="reference">
                <el-input @input="onPasswordChange" type="password" v-model="password.new" placeholder="输入新密码"></el-input>
              </div>
            </el-popover>
          </el-form-item>
          <el-form-item prop="checknew">
            <div style="font-size: 16px;font-weight: bold;margin-bottom: 20px;">
              确认新密码
            </div>
            <el-input type="password" v-model="password.checknew" placeholder="再次输入新密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" class="g-confirm-btn" @click="onSubmitPassword">确定</el-button>
            <el-button size="medium" class="g-cancel-btn" @click="isUpdatePassword = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>

<script>
import VDistpicker from 'v-distpicker';
import { mapState, mapGetters, mapActions } from 'vuex';
import Wechat from '@/assets/img/other/wechat.png'
import Calendar from '@/assets/img/other/calendar.png'
import Phone from '@/assets/img/other/phone.png'
import email from '@/assets/img/other/email.png'
import down from '@/assets/img/other/down.png'

import smallLogo from '@/assets/img/smallLogo.png'
import aes from '@/libs/aes'
import wxBindingComponent from "../../../components/wxComponent/wxBindingComponent.vue";
export default {
  name: 'dataInfomation',

  components:{
    VDistpicker,
    wxBindingComponent
  },

  data () {
    let validateMobile = (rule, value, callback) => {
      const pattern = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      // console.log(value);

			if (!value) {
				callback(new Error('请输入手机号'));
			} else if (value.toString().length !== 11 ) {
				callback(new Error('请输入正确的手机号'))
			} else if (!pattern.test(value)) {
				callback(new Error('请输入正确格式的手机号'))
			} else {
				callback();
			}
    };
    let validatePass = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入新密码'));
			} else if (value.toString().length < 6 || value.toString().length > 16) {
				callback(new Error('密码长度为6 - 16个字符'))
			} else {
				callback();
			}
    };
		let validatePass2 = (rule, value, callback) => {
	      if (value === '') {
	      callback(new Error('请再次输入密码'));
	      } else if (value !== this.password.new) {
	      callback(new Error('两次输入密码不一致!'));
	      } else {
	      callback();
	      }
	  };
    return {
      wechar_notice: true,
      wechar_report_trial: true,
      wechar_report_review: true,
      wechar_report_appeal: true,
      wechar_campaign_trial: true,
      wechar_campaign_referral: true,
      visibleShow: false,
      passwordPercent: 33,
      customColors: [
        {color: '#f56c6c', percentage: 34},
        {color: '#e6a23c', percentage: 67},
        {color: '#5cb87a', percentage: 100},
      ],
      passwordStatus: 'low',
      password: {},
      mobileRules: {
        mobile: [
            // { required: true, validator: validateMobile, trigger: 'blur' }
            {  required: true, message: '请输入手机号', trigger: 'blur' }
        ],
      },
      companyRules: {
        address: [
            { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        contact: [
            { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
      },
      passwordRules: {
        new: [
            { required: true, validator: validatePass, trigger: 'blur' }
        ],
        checknew: [
            { required: true, validator: validatePass2, trigger: 'blur' }
        ],
        current: [
            { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
      },
      showWechatDialog: false,
      isUpdatePassword: false,
      timer: null,
      newmobile: {},
      currentMobileStep: 0,
      codeNumber: 0,
      mobile: {},
      selectArea:{
        province:'',city:'',area:''
      },
      form: {},
      showEditDialog: false,
      wechat: Wechat,
      calendar: Calendar,
      phone: Phone,
      email: email,
      down: down,
      smallLogo: smallLogo,
      isBindMobile: false,
      theEditorShow: false,
      exEmail: '',
    }
  },

  methods: {
    // 插件下载
    onBindDown(e) {
      let url
      if (e == 1) {
        url = 'https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/%E9%B9%B0%E6%99%BABRM%E6%8F%92%E4%BB%B6.crx'
      } else if (e == 2) {
        url = 'https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/360%E6%80%A5%E9%80%9F%E6%B5%8F%E8%A7%88%E5%99%A811.0.exe'
      } else {
        url = 'https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/sysm.png'
      }
      window.open(url, "_blank");
    },
    onBindemail(email) {
      this.theEditorShow = true
      if (email) {
        this.exEmail = email
      } else {
        this.exEmail = ''
      }
    },
    isEmail (s) {
      return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
    },
    submitForm() {
      if (!this.isEmail(this.exEmail)) {
        this.$message({
          message: '请输入正确的邮箱格式',
          type: 'warning'
        });
        return
      }
      let params = {
        email: this.exEmail,
      }
      fetch({
        url: "hcm/user/setEmail",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.$message({
            message: '修改成功',
            type: 'success'
          });
        }
        this.theEditorShow = false
        this.load();
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    updateWechar(e) {
      let typeNum
      let typeName
      if (e == 1) {
        typeNum = this.wechar_notice ? 1 : 0
        typeName = 'wechar_notice'
      } else if (e == 2) {
        typeNum = this.wechar_report_trial ? 1 : 0
        typeName = 'wechar_report_trial'
      } else if (e == 3) {
        typeNum = this.wechar_report_review ? 1 : 0
        typeName = 'wechar_report_review'
      } else if (e == 4) {
        typeNum = this.wechar_report_appeal ? 1 : 0
        typeName = 'wechar_report_appeal'
      } else if (e == 5) {
        typeNum = this.wechar_campaign_trial ? 1 : 0
        typeName = 'wechar_campaign_trial'
      } else if (e == 6) {
        typeNum = this.wechar_campaign_referral ? 1 : 0
        typeName = 'wechar_campaign_referral'
      }
      console.log(typeNum)
      console.log(typeName)
      let params = {
        key: typeName,
        value: typeNum,
      }
      fetch({
        url: "hcm/cus/updateWechar",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.$message({
            message: '修改成功',
            type: 'success'
          });
        }
        this.selectbmcSetting()
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    selectbmcSetting() {
      fetch({
        url: "hcm/cus/selectbmcSetting",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.wechar_notice = res.data.wecharNotice
          this.wechar_report_trial = res.data.wecharReportTrial
          this.wechar_report_review = res.data.wecharReportReview
          this.wechar_report_appeal = res.data.wecharReportAppeal
          this.wechar_campaign_trial = res.data.wecharCampaignTrial
          this.wechar_campaign_referral = res.data.wecharCampaignReferral
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    // 地区选区取值(省)
    onChangeProvince(a){
      this.form.province = a.value;
    },
    onChangeCity(a){ //(市)
      this.form.city = a.value;
    },
    onChangeArea(a){  //(区)
      this.form.strict = a.value;
    },
    onSubmitCompany() {
      this.$refs['company'].validate((valid) => {
        if(valid) {
          let data = {
            companyname: this.form.companyname,
            contact: this.form.contact,
            province: this.form.province,
            city: this.form.city,
            strict: this.form.strict,
            address: this.form.address,
            bmcid: this.myInfo.bmcid
          }

          this.reqEditCompany(data).then(res => {
            if(res.status === '10000') {
              this.load();
              this.showEditDialog = false;
            }
          })
        }

      })
    },
    onBindWechat(openid) {
      console.log(this.userInfo.openid)
      let data = {
        openid: openid,
        userid: this.userInfo.id,
        usertype: 'c',
        domainname: window.location.host.substring(0, window.location.host.indexOf("."))
      }
      if(this.userInfo.openid) {
        this.reqUnbindWx(data).then((res) => {
          if(res.status === '10000') {
            this.visibleShow = false
            this.$message.success('解绑成功');
            this.load();
          }
        })
      }else {
        this.$refs.childWxBinding.getbmcwx('c',this.userInfo.id,openid)
      }
    },
    ...mapActions([
      'reqMoblieCode',
      'reqMyInfomation',
      'reqBindMobile',
      'reqUpdatePassword',
      'reqEditCompany',
      'reqUnbindWx',
      'reqValidateSMS',
      'reqUser',
    ]),
    onUpdatePassword() {
      this.passwordPercent = 33;
      this.isUpdatePassword = true;
    },
    onSubmitPassword() {
      this.$refs['password'].validate((valid) => {
        if (valid) {
          let data = {
            password: aes.encrypt(this.password.new, 'hcmabcdefghijklm'),
            oldPassword: aes.encrypt(this.password.current, 'hcmabcdefghijklm'),
            username: this.myInfo.username
          }
          this.reqUpdatePassword(data).then((res) => {
            if(res.status === '10000') {
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
            }
            if(res.status === '400') {
              this.$message({
                message: `${res.message}`,
                type: 'error'
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onPasswordChange(value) {
      let numberReg = /^[0-9]*$/;
      let bigReg = /^[A-Z]+$/;
      let smallReg = /^[a-z]+$/;
      let specialReg = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/;
      let number = false;
      let small = false;
      let big = false;
      let special = false;
      let strArr = value.split("");
      if(strArr.length < 6) {
        this.passwordPercent = 33;
      }else if(6 < strArr.length < 16){
        for(let i of strArr) {
          if(numberReg.test(i)) {
            number = true;
          }
          if(bigReg.test(i)) {
            big = true;
          }
          if(smallReg.test(i)) {
            small = true;
          }
          if(specialReg.test(i)) {
            special = true;
          }

        }
        let res = [
          number, small, big, special
        ]
        let trueRes = res.filter(item => {
          return item === true;
        })
        if(trueRes.length === 1) {
          this.passwordPercent = 33;
        }else if(2 === trueRes.length || trueRes.length === 3) {
          this.passwordPercent = 66;
        }else if(trueRes.length === 4) {
          this.passwordPercent = 100;
        }
      }
    },
    getMobileCode(step) {
      let data;
      if(step === 1) {
        data = {
          mobile: this.userInfo.mobile,
          codeType: 'HCM_UPM',
          usertype: localStorage.getItem('usertype')
        }
      }else {
        if (!this.newmobile.mobile) {
          this.$message({
            message: '请输入手机号码',
            type: 'warning'
          });
          return;
        }
        data = {
          mobile: this.newmobile.mobile,
          codeType: 'HCM_BIND',
          usertype: localStorage.getItem('usertype')
        }
      }


      this.reqMoblieCode(data).then((res) => {
        if(res.status === '400' || res.status === '410') {
          this.$message.error(res.message);
          return ;
        }
        // if() {
        //   this.$message.error(res.message);
        //   return;
        // }
        this.codeNumber = 60;
        this.handleTimer();
      })

    },
    handleTimer() {
      this.timer = setTimeout(() => {
          this.codeNumber--;
          if(!this.codeNumber) {
            clearTimeout(this.timer);
            return
          }
          this.handleTimer();
        }, 1000);
    },
    reinitTimer() {
      this.codeNumber = 0;
      clearTimeout(this.timer);
    },
    onConfirmCode(step) {
      this.reinitTimer();
      if(step === 2) {

        let data = {
          mobile: this.newmobile.mobile,
          code: this.newmobile.code
        }
        this.$refs['newmobile'].validate((valid) => {
          if (!this.newmobile.code) {
            this.$message({
              message: '请输入验证码',
              type: 'warning'
            });
            return;
          }
          if(valid) {
            this.reqValidateSMS(data).then((res) => {
              if(res) {
                this.reqBindMobile({
                  mobile: this.newmobile.mobile
                }).then(() => {
                  this.currentMobileStep = 2;
                })
              } else {
                this.$message({
                  message: '验证码错误',
                  type: 'warning'
                });
                return;
              }
            })
          }
        })

      }else {
        if (!this.userInfo.mobile) {
          this.$message({
            message: '请输入手机号码',
            type: 'warning'
          });
          return;
        }
        if (!this.mobile.code) {
          this.$message({
            message: '请输入验证码',
            type: 'warning'
          });
          return;
        }
        let data = {
          mobile: this.userInfo.mobile,
          code: this.mobile.code
        }
        this.reqValidateSMS(data).then((res) => {
          if(res == false) {
            this.$message({
              message: '验证码错误',
              type: 'warning'
            });
            return;
          } else {
            this.currentMobileStep += 1;
          }
        })
      }

    },
    onBindMobile() {
      this.reinitTimer();
      this.mobile = {};
      this.newmobile = {};
      this.currentMobileStep = 0;
      this.isBindMobile = true;
    },
    onChangePage() {
      this.isBindMobile = false;
      this.isUpdatePassword = false;
    },
    load() {
      this.reqMyInfomation();
      this.reqUser();
    },
  },

  computed: {
    hasMobile() {
      return this.userInfo.mobile ? true : false;
    },
    ...mapState({
      userInfo: state => state.myInfomation.userInfo,
      myInfo: state => state.myInfomation.myInfo
    })
  },

  created() {
    this.load();
  },

  mounted() {
    this.selectbmcSetting()
  },
}
</script>


<style lang='scss'>
@import "style/activityDeclaration.scss";
@import "style/myInfomation.scss";
.breadcrumb-box .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: bold;
}
.peoCard {
  background-color: #fff;
  padding: 20px;
}

#mainDialog {
  .el-dialog__header {
    border-bottom: none;
  }
}

.breadcrumb-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #fff;
  padding-left: 20px;
}
</style>
